"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = require("lodash");
var defaultSearchState = {
  'finProOrAgencySelection': 'Financial Professional',
  'nameOrZipCodeInputSelection': 'New York, NY 10001',
  'searchByName': false,
  'languageOptions': [],
  'specialityOptions': [],
  'distanceFilterSelection': 'Distance: Within 5 Miles',
  'distanceFilterSelectionIndex': 1,
  'lat': 40.75368539,
  'lng': -73.9991637,
  'lastSearchedTerm': 'New York, NY 10001',
  'lastSearchedWasByName': false
};
var _default = exports.default = defaultSearchState;